var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 0H5.25C2.36276 0 0 2.36173 0 5.25V15.75C0 18.6372 2.36276 21 5.25 21H15.75C18.6372 21 21 18.6372 21 15.75V5.25C21 2.36173 18.6372 0 15.75 0ZM10.5 14.8748C8.08341 14.8748 6.12491 12.9155 6.12491 10.5C6.12491 8.08341 8.08341 6.12491 10.5 6.12491C12.9155 6.12491 14.8751 8.08341 14.8751 10.5C14.8751 12.9155 12.9155 14.8748 10.5 14.8748ZM16.1876 6.12491C15.462 6.12491 14.8751 5.53716 14.8751 4.81241C14.8751 4.08767 15.462 3.49991 16.1876 3.49991C16.9132 3.49991 17.5001 4.08767 17.5001 4.81241C17.5001 5.53716 16.9132 6.12491 16.1876 6.12491Z",
    fill: "#C5395C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4ee7b6478a141e38ff7e69f1eecfdf13.svg";
export { ForwardRef as ReactComponent };